export default __webpack_public_path__ + "static/media/title.de7a2384.jpg";